module.exports = __webpack_public_path__ + "img/6.277d91c0.jpg";